import { createSlice } from "@reduxjs/toolkit";
import GlobalNavigation from "../../Common/GlobalNavigationObj";
import { toast } from "react-toastify";
import { MAXIMUM_5_PATIENTS_CAN_BE_OPENED } from "Common/ToastConstants";

const initialState = {
  sidebar: true,
  tabsModal: {},
  activeTab: "",
  // mainTab: { name: "dashboard", key: 1, right: true },
  // subTab: { name: "", key: 0, right: true },
  // innerSubTab: { name: "", key: 0, right: true },
  patients: [
    {
      active: true,
      id: 0,
      subTab: "",
      name: "Search",
      accountNum: 0,
      unsavedChanges: false,
      insuranceData: { status: false, editMode: false },
    },
  ],

  insurancePayment: {
    pID: 0,
    InsData: {
      paymenttype: "ERA_EOB",
      payerid: "",
      payerName: "",
      checknumber: "",
      checkdatefrom: "",
      checkdateto: "",
      depositdatefrom: "",
      depositdateto: "",
      poststatus: "All",
      entrydatefrom: "",
      entrydateto: "",
      receiveddatefrom: "",
      receiveddateto: "",
      visitid: "",
      posteddatefrom: "",
      posteddateto: "",
      dateType: "Check Date",
    },
    rowData: null,
  },
  submission: [
    {
      parentKey: 7,
      parentName: "submission",
      key: 8,
      name: "submission",
      title: "Submission",
      active: true,
      data: { activeTab: "unbilled", visitValidation: "Non-Scrubbed" },
    },
    {
      parentKey: 7,
      parentName: "submission",
      key: 9,
      name: "submissionLog",
      title: "Submission Log",
      active: false,
      data: {},
    },
    {
      parentKey: 7,
      parentName: "submission",
      key: 10,
      name: "ediResponseLog",
      title: "EDI Response Log",
      active: false,
      data: {},
    },
    // { parentKey: 7, parentName: "submission", key: 11, name: "patientStatement", title: "Patient Statement", active: false, data: {} },
  ],
};

const getNavigationName = (name) =>
  GlobalNavigation.find(
    (tab) => tab.name === name || tab.navigationName === name
  )?.navigationName ?? name;

export const TabsSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    activeMainTab: (state, action) => {
      state["activeTab"] = action.payload.key;

      state["mainTab"] = action.payload;
      if (!state.tabsModal[getNavigationName(action.payload.name)])
        state.tabsModal[getNavigationName(action.payload.name)] = true;

      state["activeTab"] = action.payload.key;
    },
    navigateToSettingsShortcut: (state, action) => {
      const settingsTab = GlobalNavigation.find((tab) => tab.title === "Settings");
      if (!settingsTab) return;
      const shortcutTabKey = action.payload;
      const requestedData = {
        ...(settingsTab.data ?? {}),
        settingsShortcutTab: shortcutTabKey,
        settingsShortcutNavId: Date.now(),
      };
      state.mainTab = {
        key: settingsTab.key,
        name: settingsTab.name,
        right: settingsTab.right,
        title: settingsTab.title,
        data: requestedData,
      };
      if (!state.tabsModal[getNavigationName(settingsTab.name)]) {
        state.tabsModal[getNavigationName(settingsTab.name)] = true;
      }
      state.activeTab = settingsTab.key;
    },
    resetTabs: (state) => {
      state["mainTab"] = null;
      state["activeTab"] = null;
      state["tabsModal"] = {};
    },
    activeSubTab: (state, action) => {
      if (!state[action.payload.parentKey]) {
        state[action.payload.parentName] = [
          { ...action.payload, active: true },
        ];
      } else {
        state[action.payload.parentName] = [
          state[action.payload.parentName].map((item) => (item.active = false)),
          { ...action.payload, active: true },
        ];
      }
    },
    activeSubmissionSubTab: (state, action) => {
      const updatedSubmissionTabs = state.submission.map((tab) => ({
        ...tab,
        active: tab.key === action.payload.subtab.key ? true : false,
        data:
          tab.key === action.payload.subtab.key
            ? action.payload.data
            : tab.data,
      }));
      state["mainTab"] = action.payload.maintab;
      state["submission"] = updatedSubmissionTabs;

      if (!state.tabsModal[getNavigationName(action.payload.maintab.name)])
        state.tabsModal[getNavigationName(action.payload.maintab.name)] = true;
      state["activeTab"] = action.payload.maintab.key;
    },

    swtichTab: (state, action) => {
      const Data = action.payload;
      let parent;
      let subTab;
      let innerSubTab;

      if (Data.parentName && Data.subTabName && Data.innerSubTabName) {
        parent = {
          ...GlobalNavigation.find((tab) => tab.name === Data.parentName),
        };
        subTab = {
          ...parent.subTabs.find((tab) => tab.name === Data.subTabName),
        };
        innerSubTab = {
          ...subTab.subTabs.find((sTab) => sTab.name === Data.innerSubTabName),
        };

        delete parent.subTabs;
        delete subTab.subTabs;
        delete innerSubTab.subTabs;

        state["mainTab"] = parent;
        state["mainTab"]["parentData"] = Data?.parentData;
        state[action.payload.parentName] = [
          {
            ...subTab,
            parentName: parent.name,
            parentKey: parent.key,
            subTabData: Data?.subTabData,
            active: true,
          },
        ];
        state[action.payload.subTabName] = [
          {
            ...innerSubTab,
            parentName: subTab.name,
            parentKey: subTab.key,
            innerSubData: Data?.innerSubData,
            active: true,
          },
        ];
      } else if (Data.parentName && Data.subTabName) {
        parent = {
          ...GlobalNavigation.find((tab) => tab.name === Data.parentName),
        };
        subTab = {
          ...parent.subTabs.find((tab) => tab.name === Data.subTabName),
        };

        delete parent.subTabs;
        delete subTab.subTabs;
        state["mainTab"] = parent;
        state[action.payload.parentName] = [
          {
            ...subTab,
            parentName: parent.name,
            subTabData: Data?.subTabData,
            parentData: Data?.parentData,
            parentKey: parent.key,
            active: true,
          },
        ];
      } else if (Data.parentName) {
        parent = {
          ...GlobalNavigation.find((tab) => tab.name === Data.parentName),
        };
        delete parent.subTabs;
        state["mainTab"] = parent;
        state["mainTab"]["parentData"] = Data?.parentData;
      }

      if (!state.tabsModal[parent.name]) state.tabsModal[parent.name] = true;

      state["activeTab"] = parent.key;
    },
    toggleSidebar: (state, action) => {
      return {
        ...state,
        sidebar: action.payload,
      };
    },
    addPatient: (state, action) => {
      const oldPatients = state.patients;
      // first check if patient is already added in array or not
      const patientExist = oldPatients.some(
        (pat) => pat.id === action.payload.id
      );
      let updatedPatients = [];

      if (patientExist) {
        updatedPatients = oldPatients.map((pat) => ({
          ...pat,
          subTab:
            pat.id === action.payload.id ? action.payload.subTab : pat.subTab,
          active: pat.id === action.payload.id, // it means pat.id === action.payload.id ? true : false
        }));
      } else {
        if (oldPatients.length >= 6) {
          toast.warning(MAXIMUM_5_PATIENTS_CAN_BE_OPENED);
          return {
            ...state,
          };
        }
        updatedPatients = oldPatients.map((pat) => ({
          ...pat,
          active: false,
        }));
        updatedPatients.push(action.payload);
      }

      state["patients"] = updatedPatients;
      state["mainTab"] = { name: "patients", key: 2, right: true };
      if (!state.tabsModal[getNavigationName("patients")])
        state.tabsModal[getNavigationName("patients")] = true;

      state["activeTab"] = 2;
    },
    removePatient: (state, action) => {
      // to remove all the patients and search tab to active
      if (!action.payload) {
        state.patients = [
          {
            active: true,
            id: 0,
            subTab: "",
            name: "Search",
          },
        ];
      }
      const patientToRemove = state.patients.find(
        (pat) => pat.id === action.payload
      );
      if (!patientToRemove) {
        return;
      }
      const updatedPatients = state.patients.filter(
        (pat) => pat.id !== action.payload
      );
      if (patientToRemove.active) {
        state.patients = updatedPatients.map((pat) => ({
          ...pat,
          active: pat.name === "Search",
        }));
      } else {
        state.patients = updatedPatients;
      }
    },
    switchToPatient: (state, action) => {
      const oldPatients = state.patients;
      const updatedPatients = oldPatients.map((pat) => ({
        ...pat,
        active: pat.id === action.payload ? true : false,
      }));
      return {
        ...state,
        patients: updatedPatients,
      };
    },
    switchToPatientSubTab: (state, action) => {
      const updatedPatients = state.patients.map((pat) => {
        let obj = { ...pat };
        if (pat.active === true) {
          return { ...obj, subTab: action.payload };
        } else {
          return obj;
        }
      });
      return {
        ...state,
        patients: updatedPatients,
      };
    },

    toggleUnsavedChagesOfPatient(state, action) {
      const patientIndex = state.patients.findIndex((i) => i.id === action.payload.patientId)
      state.patients[patientIndex].name = action.payload.name || state.patients[patientIndex].name
      state.patients[patientIndex].unsavedChanges = action.payload.status
    },
    togglePatientIns: (state, action) => {
      const oldPatients = state.patients;
      const updatedPatients = oldPatients.map((pat) => ({
        ...pat,
        insuranceData:
          pat.id === action.payload.patientId
            ? action.payload.insuranceData
            : pat.insuranceData,
        subTab: pat.id === action.payload.patientId ? "Overview" : pat.subTab,
      }));
      return {
        ...state,
        patients: updatedPatients,
      };
    },





    setInsurancePayment: (state, action) => {
      state["insurancePayment"] = action.payload.data;
      state["mainTab"] = action.payload.mainTab;

      if (!state.tabsModal[action.payload.mainTab.navigationName])
        state.tabsModal[action.payload.mainTab.navigationName] = true;
      state["activeTab"] = action.payload.mainTab.key;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  toggleSidebar,
  resetTabs,
  activeMainTab,
  activeSubTab,
  addPatient,
  switchToPatient,
  switchToPatientSubTab,
  addToSubTab,
  closePatient,
  removePatient,
  swtichTab,
  activeSubmissionSubTab,
  toggleUnsavedChagesOfPatient,
  navigateToSettingsShortcut,
  addClaim,
  switchToClaim,
  removeClaim,
  changeClaimStatus,
  setInsurancePayment,
  togglePatientIns,
} = TabsSlice.actions;

export default TabsSlice.reducer;
